import React, { useEffect, useState } from 'react';
import { useMap } from './CustomHooks/useMap';
import MapEditor from './components/MapEditor';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function QuickAssessmentModal({
  open,
  onClose,
  sectionData,
  mapData,
  saveMapCoordinates,
  deleteMapCoordinates,
  boundaryAlreadyExists,
  step,
  setStep,
  reference,
  setReference,
  handleContinue,
  onSave,
}) {
  const { mapState, mapActions } = useMap({
    mapData,
    sectionData,
    open,
    isMapLoaded: step === 'map',
  });

  const [value, setValue] = useState('customer');
  const [customerName, setCustomerName] = useState('');
  const [destinationName, setDestinationName] = useState('');

  useEffect(() => {
    if (open) {
      mapActions.resetMap();
    }
  }, [open]);

  const handleSave = async () => {
    const requiredLabel = value === 'site' ? 'stacking area' : 'boundary';

    const isValid = mapState.polygons.some(item => item.mapLabel?.toLowerCase() === requiredLabel);

    if (!isValid) {
      alert(`Please draw atleast one ${requiredLabel}`);
      return;
    }

    // DATA TO PASS BASED ON SITE OR CUSTOMER
    const passLabel = value === 'site' ? 'boundary' : 'stacking area';

    const firstPolygon = mapState.polygons.find(item => item.mapLabel?.toLowerCase() === passLabel);

    if (!firstPolygon) {
      alert(`No ${passLabel} found to save`);
      return;
    }

    const customers = {
      customerName,
      destinationName,
    };

    await onSave(value, [firstPolygon], customers);
  };

  const handleBack = () => {
    setStep('ref');
  };

  return (
    <Dialog
      open={open}
      maxWidth={step === 'ref' ? 'sm' : false}
      fullWidth
      PaperProps={{
        sx:
          step === 'ref'
            ? {}
            : {
                width: '95vw',
                maxWidth: '95vw',
                height: '95vh',
              },
      }}
      onClose={onClose}>
      <DialogTitle>Quick Assessment</DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'grey.500',
        }}>
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 2 }}>
        {/* STEP 1: Reference */}
        {step === 'ref' && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Reference"
                value={reference}
                onChange={e => setReference(e.target.value)}
                variant="outlined"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl>
                <FormLabel id="geofence-type-label">Geofence Type</FormLabel>

                <RadioGroup
                  row
                  aria-labelledby="geofence-type-label"
                  name="geofence-type"
                  value={value}
                  onChange={e => setValue(e.target.value)}>
                  {/* <FormControlLabel value="site" control={<Radio />} label="Site" /> */}
                  <FormControlLabel value="customer" control={<Radio />} label="Customer" />
                </RadioGroup>
              </FormControl>
            </Grid>
            {/* If Customer */}
            {value === 'customer' && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Customer Name"
                    value={customerName}
                    onChange={e => setCustomerName(e.target.value)}
                    variant="outlined"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Destination Name"
                    value={destinationName}
                    onChange={e => setDestinationName(e.target.value)}
                    variant="outlined"
                    autoFocus
                  />
                </Grid>
              </>
            )}
          </Grid>
        )}

        {/* STEP 2: Map */}
        {step === 'map' && (
          <Box sx={{ mt: 2 }}>
            <MapEditor
              mapState={mapState}
              mapActions={mapActions}
              mapData={mapData}
              saveMapCoordinates={saveMapCoordinates}
              deleteMapCoordinates={deleteMapCoordinates}
              boundaryAlreadyExists={boundaryAlreadyExists}
              mapHeight="64vh"
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        {step === 'map' && (
          <Button onClick={handleBack} color="inherit">
            Back
          </Button>
        )}
        <Button onClick={onClose} color="inherit">
          Close
        </Button>

        {step === 'ref' ? (
          <Button variant="contained" onClick={handleContinue} disabled={!reference.trim()}>
            Continue
          </Button>
        ) : (
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save Changes
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default QuickAssessmentModal;
